<template>
    <div class="column_center_start">
        <div class="title" style="font-size: 24px; color: #666666;" v-if="useOnlinePayment">{{ displayLinePayStatus}}</div>
        <div class="title" style="font-size: 24px; color: #666666;" v-else>{{ displayPaymentStatus }}</div>
        <text class="title" style="font-size: 16px; color: #FD5001; margin-top: 8px;" v-if="useOnlinePayment && (linePayCancelled || linePayFailed)">此筆訂單付款失敗請往下滑，重新選擇支付</text>
        <QRCode :value="orderNumber" :size="84" level="H" class="my-4" v-if="showQRCode" />
        <text class="row_center_center button-icon" style="font-size: 84px; color: #FD5001; margin: 0;" v-if="showErrorIcon">error</text>
        <!-- <text id="restart_alt" class="row_center_center button-icon waiting_circle h-20 my-2.5"
        style="font-size: 84px; color: #FD5001;" v-if="showWaitingIcon">restart_alt</text>
           Modify By Jaden: 2025-12-05 -->
    </div>

    <!-- <div class="column_center_start" v-if="paymentProcessing">
        <text class="title" style="font-size: 24px; color: #666666;" v-if="useOnlinePayment">{{ displayLinePayStatus}}</text>
        <text class="title" style="font-size: 24px; color: #666666;" v-else>訂單待付款</text>
        <QRCode :value="orderNumber" :size="84" level="H" class="my-4" />
    </div>
    <div class="column_center_start" v-if="paymentUserCancelled || paymentStoreCancelled">
        <text class="title" style="font-size: 24px; color: #666666;" v-if="useOnlinePayment">{{ displayLinePayStatus}}</text>
        <text class="title" style="font-size: 24px; color: #666666;" v-else>訂單已取消</text>
        <text class="row_center_center button-icon" style="font-size: 84px; color: #FD5001; margin: 0;">error</text>
    </div>
    <div class="column_center_start" v-if="paymentPaid">
        <text class="title" style="font-size: 24px; color: #666666;" v-if="useOnlinePayment">{{ displayLinePayStatus}}</text>
        <text class="title" style="font-size: 24px; color: #666666;" v-else>訂單已成立</text>
        <QRCode :value="orderNumber" :size="84" level="H" class="my-4" />
    </div>

    <div class="column_center_start" v-if="paymentUnprocessed">
        <text class="title" style="font-size: 24px; color: #666666;" v-if="useOnlinePayment">{{ displayLinePayStatus}}</text>
        <text class="title" style="font-size: 24px; color: #666666;" v-else>等待接單中</text>
        <text id="restart_alt" class="row_center_center button-icon waiting_circle h-20 my-2.5"
            style="font-size: 84px; color: #FD5001;">restart_alt</text>
    </div> -->
</template>
<script>
import QRCode from "qrcode.vue";
export default {
    components: {
        QRCode
    },
    props: {
        orderInfo: {
            type: Object,
            required: true
        },
        orderNumber: {
            type: String,
            default: ''
        }
    },
    computed: {
        showErrorIcon() {
            if (this.useOnlinePayment) {
                return this.linePayCancelled || this.linePayFailed
            }
            return this.paymentUserCancelled || this.paymentStoreCancelled
        },
        showQRCode() {
            if (this.useOnlinePayment) {
                return this.linePayUnpaid || this.linePayPaid
            }
            return this.paymentProcessing || this.paymentPaid
        },
        showWaitingIcon() {
            if (this.useOnlinePayment) return false
            return this.paymentUnprocessed
        },
        paymentUnprocessed() {
            return this.paymentStatus === 'unprocessed'
        },
        paymentUserCancelled() {
            return this.paymentStatus === 'userCancelled'
        },
        paymentProcessing() {
            return this.paymentStatus === 'processing'
        },
        paymentPaid() {
            return this.paymentStatus === 'paid'
        },
        paymentStoreCancelled() {
            return this.paymentStatus === 'storeCancelled'
        },
        displayPaymentStatus() {
            if (this.paymentUnprocessed) {
                return '訂單已送出'
            } else if (this.paymentUserCancelled) {
                return '訂單已取消'
            } else if (this.paymentProcessing) {
                return '訂單待付款'
            } else if (this.paymentPaid) {
                return '訂單已成立'
            }
            return '訂單待付款'
        },
        useOnlinePayment() {
            return this.orderInfo.use_online_payment === 1
        },
        paymentStatus() {
            // 訂單狀態 order_status
            // 0: 未處理
            // 1: 使用者取消
            // 2: 處理中
            // 3: 已結帳
            // 4: 店家取消訂單
            switch (this.orderInfo.order_status) {
                case 0:
                    return 'unprocessed'
                case 1:
                    return 'userCancelled'
                case 2:
                    return 'processing'
                case 3:
                    return 'paid'
                case 4:
                    return 'storeCancelled'
                default:
                    return 'processing'
            }
        },
        onlinePaymentStatus() {
            return this.orderInfo.online_payment_status
        },
        linePayUnpaid() {
            return this.onlinePaymentStatus === 0
        },
        linePayPaid() {
            return this.onlinePaymentStatus === 1
        },
        linePayCancelled() {
            return this.onlinePaymentStatus === 2
        },
        linePayFailed() {
            return this.onlinePaymentStatus === 3
        },
        displayLinePayStatus() {
            if (this.linePayUnpaid) {
                return '未付款'
            } else if (this.linePayPaid) {
                return '付款成功'
            }
            return '付款失敗'
        }
    }
}
</script>
<style>
@keyframes rotateAnimation {
    0% {
        transform: rotate(0deg);
        animation-timing-function: ease-in;
    }

    100% {
        transform: rotate(-360deg);
        animation-timing-function: linear;
    }
}

.waiting_circle {
    animation: rotateAnimation 1.4s ease-in-out infinite;
    transform-origin: center center;
    transition: transform 0.4s ease-in-out;
}
</style>
